import React, { useState } from "react";
import { products } from "./data/aluminiumProfileData";
import { Helmet } from "react-helmet";
import "../../App.css";
import banner from "../../assets/hinge-banner.webp";

const AluminiumProfile = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");

  const getYouTubeWatchUrl = (embedUrl) => {
    if (!embedUrl) return "#";
    const videoId = embedUrl.split("/embed/")[1];
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  const filteredProducts = products.filter(
    (product) => product.category === "aluminium-profile"
  );
  if (!filteredProducts.length) return <p>No products found.</p>;

  return (
    <div className="product-container">

      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/"
  />
        <title>Soft Close Hinges for Kitchen Cabinets | Slimline Hardware</title>
        <meta
          name="description"
          content="Buy high-quality soft close cabinet hinges for modular kitchen. Durable, rust-proof & smooth closing hinges."
        />
      </Helmet>

      {/* BANNER */}
      <div className="hinge-banners">
        <img src={banner} alt="Hinge Banner"  loading="lazy"/>
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 style={{ textAlign: "center", fontSize: "2rem", padding: "10px" }}>
      ALUMINIUM PROFILES 
      </h2>

      {!selectedProduct ? (

        <div className="product-grid">
          {filteredProducts.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedProduct(item);
                setMainImage(item.mainImage);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
              <img src={item.mainImage} alt={item.name}  loading="lazy"/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (
        <>
          <button
            className="back-btn"
            onClick={() => {
              setSelectedProduct(null);
              setMainImage("");
              setActiveFAQ(null);
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* LEFT */}
            <div className="left-box">

              <div className="hinge-image">
                <img src={mainImage} alt={selectedProduct.name} />
              </div>

              <div className="hinge-thumbnails">
                {selectedProduct.thumbnails.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt=""
                    onClick={() => setMainImage(img)}
                     loading="lazy"
                  />
                ))}
              </div>

              {selectedProduct.video && (
                <div className="product-video">
                  <iframe
                    width="100%"
                    height="300"
                    src={selectedProduct.video}
                    title="Product Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

            </div>

            {/* RIGHT */}
            <div className="hinge-info">

              <h2>{selectedProduct.name}</h2>

              <div className="price-box">
                <span className="price">{selectedProduct.price}</span>
                <span className="old-price">{selectedProduct.oldPrice}</span>
              </div>

              <div className="product-meta">
                <p><strong>SKU:</strong> {selectedProduct.sku}</p>
                <p><strong>Status:</strong> {selectedProduct.stock}</p>
              </div>

              {/* BUTTONS */}
              <div className="btns">

                {selectedProduct.catalogue && (
                  <a href={selectedProduct.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedProduct.inquiry && (
                  <a href={selectedProduct.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedProduct.video && (
                  <a
                    href={getYouTubeWatchUrl(selectedProduct.video)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button
                  className={activeTab === "desc" ? "active" : ""}
                  onClick={() => setActiveTab("desc")}
                >
                  Description
                </button>

                <button
                  className={activeTab === "info" ? "active" : ""}
                  onClick={() => setActiveTab("info")}
                >
                  Additional Info
                </button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedProduct.short}</p>
                  <ul>
                    {selectedProduct.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* ADDITIONAL INFO */}
              {activeTab === "info" && (
                <div className="info-table">
                  {selectedProduct.specifications?.length ? (
                    <table>
                      <tbody>
                        {selectedProduct.specifications.map((s, i) => (
                          <tr key={i}>
                            <td>{s.label}</td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}
                </div>
              )}

            </div>

          </div>

          {/* SPEC TABLE */}
          {selectedProduct.specTable && (
            <div className="spec-section">
              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedProduct.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* FAQ */}
          {selectedProduct.faq && (
            <div className="faq-section">
              <h2>Frequently Asked Questions</h2>

              {selectedProduct.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span>{activeFAQ === index ? "-" : "+"}</span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}
            </div>
          )}

        </>
      )}

    </div>
  );
};

export default AluminiumProfile;